 <!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 01/01/2019
  -->

<template>
	<div class="fill-height-root relative">
		<BackHeader
			@click="onBackPressed"
			title="Session settings"/>
<!--		<div class="w-100" style="flex: 0 0 4px;min-height: 0;" :style="{background: eventType.eventColor}"/>-->

		<TabbedLayout
			v-if="eventType"
			v-bind="$attrs"

			:backRouteName="backRouteName"
			paramTabName="schedulerSettingTab"
			:eventType="eventType"
			:paymentIntegrations="paymentIntegrations"
			:tabs="tabs"
		/>

		<LoadingIndicator
			v-if="isProgressShowing"
			class="center-absolute"
			:message="progressText"/>
	</div>
</template>

<script>
import TabbedLayout from "@/core/components/Tabs/TabbedLayout.vue";
import TabItem from "@/core/components/Tabs/TabItem";

import BaseComponent from "@/core/components/BaseComponent.vue";
import LoadingIndicator from "@/core/components/LoadingIndicator.vue";
import EventType from "@shared/scheduler/EventType";
import BackHeader from "@/core/components/BackHeader.vue";
import EventTypeGeneralSettingsView
	from "@/core/modules/coach/Scheduler/EventTypes/Settings/SchedulerGeneralSettings.vue";
import EventTypeAvailabilitySettingsView
	from "@/core/modules/coach/Scheduler/EventTypes/Settings/EventTypeAvailabilitySettingsView.vue";
import EventTypeAdditionalSettingsView
	from "@/core/modules/coach/Scheduler/EventTypes/Settings/SchedulerAdditionalSettingsView.vue";
import SessionIntakeFormView from "@/core/modules/coach/Scheduler/EventTypes/Settings/SessionIntakeFormView.vue";

export default {
	extends: BaseComponent,
	name: "EventTypeSettingsView",
	components: {
		BackHeader, LoadingIndicator, TabbedLayout
	},

	props: {
		eventTypeId: String,
		eventTypeProp: EventType,
		backRouteName: String,
		hideIntakeTab: Boolean,
		hideAvailabilityTab: Boolean,
		hideAdvancedTab: Boolean,
	},

	watch: {
		eventTypeProp: {
			immediate: true,
			handler() {
				console.log("this.eventTypeProp changed: ", this.eventTypeProp)
				if(this.eventTypeProp){
					this.eventType = this.eventTypeProp
				}
			}
		}
	},

	data() {
		return {
			eventType: null,
			paymentIntegrations: null,
			tabs: []
		}
	},

	async mounted() {
		this.tabs = [
			new TabItem("General Settings", "general", {component: EventTypeGeneralSettingsView}),
			!this.hideIntakeTab && this.isRecoveryApp ? new TabItem("In-Take Form", "intakeform", {component: SessionIntakeFormView}) : null,
			!this.hideAvailabilityTab ? new TabItem("Session Availability", "availability", {component: EventTypeAvailabilitySettingsView}) : null,
			// !this.hideAdvancedTab ? new TabItem("Reminders", "reminders", {component: EventTypeAdditionalSettingsView}) : null,
			!this.hideAdvancedTab ? new TabItem("Advanced Settings", "additional", {component: EventTypeAdditionalSettingsView}) : null,
			// new TabItem("Forms", "forms"),
		].filter(item => !!item)
		await this.loadSessionType()
	},

	methods: {

		onBackPressed() {
			if(this.backRouteName){
				this.goBackOrigin(this.backRouteName, this.$route.params, this.$route.query)
			} else {
				this.$emit("onBackPressed")
			}
		},

		async loadSessionType() {
			console.log("EventTypeSettingsView: loadSessionType")
			let [eventType, paymentIntegrations] = await this.handleAsync([
				this.eventType ? this.eventType : this.$dataManager.apiGetEventType({sessionTypeId: this.eventTypeId, coachId: this.getCoachId()}),
				// this.$dataManager.getPaymentIntegrationsMain(),
			])

			console.log("loadSessionType: paymentIntegrations = ", paymentIntegrations)

			this.eventType = eventType
			this.paymentIntegrations = paymentIntegrations
		},

		// createTabParams(){
		// 	return {
		// 		eventTypeProp: this.eventType || this.eventTypeProp
		// 	}
		// }
	}
}
</script>

<style>

</style>

